import {useToast} from "vue-toastification";
import type { ToastOptions } from "vue-toastification/dist/types/types";

const toast = useToast();
const infoToastOptions = {icon: "dx-icon dx-icon-info"};
const warningToastOptions = {icon: "dx-icon dx-icon-warning"};
const errorToastOptions = {icon: "dx-icon dx-icon-clear"};
const successToastOptions = {icon: "dx-icon dx-icon-check"};

export function toastInfo(text: string, options?: ToastOptions & { type: "info" | undefined }) {
    toast.info(text, {...infoToastOptions, ...options});
}

export function toastWarning(text: string, options?: ToastOptions & { type: "warning" | undefined }) {
    toast.warning(text, {...warningToastOptions, ...options});
}

export function toastError(text: string, options?: ToastOptions & { type: "error" | undefined }) {
    toast.error(text, {...errorToastOptions, ...options});
}

export function toastSuccess(text: string, options?: ToastOptions & { type: "success" | undefined }) {
    toast.success(text, {...successToastOptions, ...options});
}